export default {
  main: {
    title: "明度与通道映射",
  },
  drawer: {
    image: "图像",
    analysis: "直方图",
    palette: "调色盘",
    ai: "AI 洞察",
  },
  card: {
    imageReference: "图像参考",
    histogram: "直方图",
    colorPalette: "颜色调色盘",
    aiInsights: "AI 洞察",
  },
  tabs: {
    color: "颜色",
    tone: "影调",
  },
  ai: {
    guideTitle: "AI 洞察",
    guideDescription:
      "通过 AI 分析获取更深入的图像洞察，包括色彩拆解、构图建议等。",
    analyze: "使用 AI 分析",
    refresh: "刷新分析",
    refreshTooltip: "刷新分析",
    analysisFailed: "分析失败：{message}",
  },
  aiAnalysis: {
    severity: {
      minor: "轻微",
      moderate: "中等",
      major: "显著",
      unknown: "未标注",
    },
  },
  taskSummary: {
    title: "任务摘要",
    currentTask: "当前任务：原图 → 目标风格 ({styleName})",
    currentTaskLabel: "当前任务：",
    currentTaskSource: "原图",
    currentTaskTarget: "目标风格",
    unknownStyle: "未指定风格",
    keyGapsTitle: "关键差距",
    priorityActionsTitle: "优先动作",
    aiOverviewTitle: "后期建议总览",
    aiDetailPreviewLabel: "完整编辑建议",
    aiDetailCta: "查看编辑指南",
    aiDetailDialogTitle: "后期建议",
    aiDetailTitle: "编辑建议",
    aiDetailClose: "关闭",
    upgradedVersion: "已更新版本",
    upgradeToView: "升级查看新版本",
    aiDetailPendingBanner: "新版本生成中，完成后将自动替换当前结果",
    aiDetailPendingHint: "当前仍为旧版本内容，新版本完成后自动替换",
    aiDetailGenerating: "正在生成新版本分析，请稍候...",
    actions: {
      uploadResult: "上传已编辑版本",
      openGuide: "解码之旅",
    },
  },
  finalReview: {
    title: "最终回顾与分享",
    upload: {
      title: "上传已编辑图像",
      description:
        "上传此任务的已编辑图像，以准备“Before/After ”预览和共享导出。",
      stateReady: "已编辑图片就绪",
      stateEmpty: "此任务尚无已编辑图像",
      template: "模板",
      beforeSource: "Before来源",
    },
    templatePreview: {
      before: "Before",
      after: "After",
    },
    uploading: "正在处理上传图片...",
    backToTask: "返回任务页",
    replaceAfter: "替换 After",
    tabs: {
      slider: "Slider",
      sideBySide: "Side by Side",
    },
    moodFrame: {
      label: "Mood Frame",
    },
    actions: {
      download: "下载分享图",
      generating: "正在生成...",
    },
  },
  aiTaskSummary: {
    title: "AI 任务总览",
    loading: "AI 正在生成任务总览...",
    placeholder: "AI 总览暂未就绪，先查看下方洞察详情。",
    temporaryIssue: "本次分析出现临时问题，请稍后再试。",
  },
  pending: {
    public: {
      title: "正在分析你的照片",
      description:
        "我们正在结合参考图拆解画面结构、色彩分布与后期差距，完成后会自动进入结果页。",
      primary: "正在拆解图像结构，请稍候…",
      stages: {
        preparing: "正在准备分析环境…",
        scanning: "正在扫描照片结构与亮度层级…",
        locating: "正在基于色彩分布进行差距定位…",
        generating: "正在结合参考图生成后续精修建议…",
      },
    },
    internal: {
      titleLoading: "正在加载分析上下文...",
      titleReady: "分析任务准备中",
      description: "系统正在初始化分析环境，完成后将自动进入结果页面。",
    },
    steps: {
      auth: "验证用户身份",
      capability: "加载功能配置",
      unlock: "恢复解锁状态",
      analyzing: "分析准备中",
      crop_deciding: "等待裁剪结果",
      submitting: "提交分析任务",
    },
    recovery: {
      processedReupload:
        "处理图资源失效，页面将使用当前素材重新补传处理图后再试。",
      originalReupload: "原图资源已失效，需要返回上传页重新建立分析素材。",
      multipleAssets: "分析素材不完整，需要返回上传页重新准备原图与处理图。",
      manualRecovery:
        "当前分析任务暂时无法自动恢复，请稍后刷新页面或重新开始分析。",
    },
    actions: {
      retryProcessed: "重新补传处理图并提交",
      retrySubmit: "重新提交分析任务",
    },
    errors: {
      insufficient_credits: "当前积分不足，分析任务未继续执行。",
      history_quota_exceeded: "当前历史配额已达上限，分析任务未继续执行。",
      payment_materialization_pending: "支付状态仍在同步，请稍后重新提交。",
      invalid_upload_asset: "分析资源尚未准备完成，请重新提交。",
      image_missing: "分析资源缺失，请返回上传页重新提交。",
      source_not_ready: "分析资源尚未就绪，请稍后重新提交。",
      processed_mismatch: "处理图与当前原图不匹配，请重新生成后再试。",
      analysis_not_ready_for_execution:
        "本地分析尚未完成，系统会在准备就绪后继续。",
      analysis_subject_id_required: "结果同步失败，请重新提交或刷新页面。",
      subject_not_found: "服务端结果暂不可用，请稍后重新同步。",
      not_implemented: "服务端尚未开通当前分析接口，请稍后再试。",
      network_timeout: "网络请求超时，请稍后重新尝试。",
      network_error: "网络异常，分析任务提交失败，请稍后重试。",
      server_error: "服务暂时异常，分析任务提交失败，请稍后重试。",
      server_unavailable: "服务暂时不可用，请稍后重试。",
      analysis_command_failed: "分析任务提交失败，请稍后重新尝试。",
      fallback: "分析任务提交失败，请稍后重新尝试。",
      bootstrap_error: "分析准备失败，请返回上传页重试。",
    },
  },
  relation: {
    errors: {
      network_error: "网络错误",
      retry_failed: "操作失败",
      manual_fallback: "手动回退旧逻辑",
      not_found_max_attempt: "超过自动上传重试次数",
      not_found: "资源不存在",
      relation_missing_max_attempt: "超过自动创建重试次数",
      relation_missing_failed: "自动创建关系失败",
      relation_restore_max_attempt: "超过自动恢复重试次数",
      relation_restore_failed: "自动恢复关系失败",
      processed_mismatch_max_attempt: "超过自动覆盖重试次数",
      processed_mismatch_failed: "自动覆盖处理图失败",
      missing_relation_id: "缺少 relation_id",
    },
  },
  guideFlow: {
    eyebrow: "引导",
    title: "一步一步看懂你的照片",
    stepIndex: "步骤 {current} / {total}",
    actions: {
      back: "上一步",
      next: "下一步",
      complete: "完成",
      exit: "退出引导",
      skipToTasklayout: "先进入任务总览",
    },
    aiGate: {
      title: "差异分析",
      description: "正在深度分析照片并提供洞察，准备好后会自动进入下一阶段。",
      waiting: "正在分析中，请稍候…",
      timeout: "等待时间较长，你可以先进入任务总览继续操作，稍后再重进引导。",
      timeoutDescription:
        "等待超时，可先进入任务总览，稍后再通过「查看引导」继续。",
      timeoutWithDuration:
        "等待超过 {duration}，你可以先进入任务总览继续操作，稍后再重进引导。",
      temporaryIssue: "本次分析出现临时问题，请稍后再试。",
      duration: {
        minute: "{count} 分钟",
        second: "{count} 秒",
      },
      positive: {
        primary: "正在扫描和拆解图像，请稍候…",
        messages: {
          0: "正在扫描照片结构与亮度层级…",
          1: "正在基于色彩分布进行差距定位…",
          2: "正在结合参考图生成后续精修建议…",
        },
      },
    },
    gap: {
      defaultTitle: "差距步骤 {index}",
      fallbackDiagnosis: "当前未获取到可展示的差距描述。",
      suggestionLabel: "建议动作：",
      evidenceLabel: "证据定位：",
      restrictedDescription: "解锁后查看该步骤的完整诊断、建议动作与证据定位。",
      dataReadingTitle: "数据阅读",
      evidenceAriaLabel: "数据解读",
      toggleEvidenceSummaryAriaLabel: "展开或收起数据摘要",
      evidenceGroupsHeader: "当前动态 Step evidence_groups",
      analysisMarkdown: {
        title: "AI 分析结果",
        description:
          "当前临时展示 AI 返回的分析内容，后续会替换为更细化的动态步骤。",
        empty: "AI 分析内容暂未生成，请稍后重试。",
      },
      empty: {
        title: "当前未检测到可展示差距",
        description:
          "这组图像当前没有可展示的 gap 项，可直接完成引导进入任务总览。",
      },
    },
    hueMapping: {
      emptyHint: "选择一个色相，查看它在两张图中的分布位置",
      selectedHint: "当前查看：{label}",
      luminanceZoneLabel: "亮度分区",
      globalPercentHint:
        "色相比例为全图统计；可选择亮度分区约束右侧预览 mask。",
      zonePercentHint:
        "色相比例按当前亮度分区内统计；右侧显示该分区内命中的 mask。",
    },
    saturationMapping: {
      emptyHint: "选择一个饱和度等级，查看它在两张图中的分布位置",
      selectedHint: "当前查看：{label}",
      luminanceZoneLabel: "亮度分区",
      globalPercentHint:
        "左侧比例为全图统计；右侧可按亮度分区查看命中的 mask。",
      zonePercentHint:
        "左侧比例按当前亮度分区内统计；右侧显示该分区内命中的 mask。",
      uploadCard: "饱和度分布 · 上传图",
      referenceCard: "饱和度分布 · 参考图",
      buckets: {
        low: "低饱和度",
        muted: "偏低饱和度",
        medium: "中饱和度",
        vibrant: "偏高饱和度",
        high: "高饱和度",
      },
    },
    labAbMapping: {
      emptyHint: "选择 A 或 B 通道分档，查看它在两张图中的色偏区域",
      selectedHint: "当前查看：{label}",
      luminanceZoneLabel: "亮度分区",
      globalPercentHint:
        "左侧比例为全图统计；右侧可按亮度分区查看命中的 mask。",
      zonePercentHint:
        "左侧比例按当前亮度分区内统计；右侧显示该分区内命中的 mask。",
      channelA: {
        title: "A 通道 · 绿 ↔ 红/品",
        buckets: [
          "强绿偏向",
          "微绿偏向",
          "中性灰",
          "微红/品偏向",
          "强红/品偏向",
        ],
      },
      channelB: {
        title: "B 通道 · 蓝 ↔ 黄",
        buckets: ["强蓝偏向", "微蓝偏向", "中性灰", "微黄偏向", "强黄偏向"],
      },
    },
    placeholders: {
      rgb: {
        title: "RGB 直方图总览",
        description:
          "查看上传图与参考图的 RGB 直方图和叠加分布，先判断主色通道与整体色彩走势。",
      },
      luminosity: {
        title: "Luminosity 直方图总览",
        description:
          "对比上传图与参考图的明度分布，快速定位整体亮度层级与潜在曝光偏差。",
      },
      mask: {
        title: "分区视图",
        description:
          "通过分区蒙版预览理解不同区域的明暗与颜色分布，为后续差异分析建立视觉锚点。",
      },
      hueMapping: {
        title: "HUE 映射",
        description:
          "在双图色环中选择目标色相，并同步查看该色相在上传图与参考图中的空间分布。",
        luminanceZoneLabel: "亮度分区",
        globalPercentHint:
          "色相比例为全图统计；可选择亮度分区约束右侧预览 mask。",
        zonePercentHint:
          "色相比例按当前亮度分区内统计；右侧显示该分区内命中的 mask。",
      },
      clippingMapping: {
        title: "死白/死黑映射",
        description:
          "基于亮度裁切阈值同步展示上传图与参考图的高光死白与阴影死黑区域分布。",
      },
      zoneBoxplotSnapshot: {
        title: "分区蒙版与统计快照",
        description:
          "沿用上方分区选择，先观察明度分区蒙版，再在下方直接查看对应分区的箱线图统计对比。",
      },
    },
  },
  atomicCapabilities: {
    title: "洞察详情",
    tabs: {
      image: "Image",
      tonalExposure: "Tonal & Exposure",
      globalColor: "Global Color",
      colorGrading: "Color Grading",
      aiInsights: "AI Insights",
    },
    image: {
      resolution: "分辨率",
      totalPixels: "总像素",
      megapixels: "百万像素",
      aspectRatio: "纵横比",
      fileFormat: "文件格式",
      sourceLabel: "上传来源",
      activeBadge: "Active",
      previewAction: "放大预览：{subject}",
      previewAltOriginal: "上传原图预览",
      previewAltCropped: "上传裁剪图预览",
      previewAltReference: "参考图预览",
      unavailable: "当前图片不可用",
      referenceMissing: "参考图缺失",
      downloadCropped: "下载裁剪图",
    },
    statistics: {
      tonalExposureTitle: "亮度硬指标（Global）",
      globalColorTitle: "全局色彩统计（Global）",
      snapshotTitle: "色度特征画像",
      mean: "Mean",
      median: "Median",
      std: "Std",
      channels: {
        labL: "LAB L",
        hslL: "HSL L",
        hslH: "HSL H",
        hslS: "HSL S",
        labA: "LAB A",
        labB: "LAB B",
      },
    },
    colorGrading: {
      zoneLabel: "分区选择",
      labTitle: "LAB 统计（{zone}）",
      hslTitle: "HSL 统计（{zone}）",
      downloadLab: "下载 LAB 统计",
      downloadHsl: "下载 HSL 统计",
      empty: "当前分区暂无统计数据",
      tendencyTitle: "分区倾向解释",
      zone: {
        global: "Global",
        blacks: "Blacks",
        shadows: "Shadows",
        midtones: "Midtones",
        highlights: "Highlights",
        whites: "Whites",
      },
      tendency: {
        temperatureCool: "LAB B 低于中性值，当前分区偏冷（蓝/青）。",
        temperatureWarm: "LAB B 高于中性值，当前分区偏暖（黄/橙）。",
        temperatureNeutral: "LAB B 接近中性值，当前分区冷暖倾向不明显。",
        tintGreen: "LAB A 低于中性值，当前分区有轻微偏绿倾向。",
        tintMagenta: "LAB A 高于中性值，当前分区有轻微偏洋红倾向。",
        tintNeutral: "LAB A 接近中性值，当前分区绿/洋红倾向不明显。",
        saturationLow: "HSL S 偏低，当前分区饱和度较弱。",
        saturationMedium: "HSL S 处于中段，当前分区饱和度中等。",
        saturationHigh: "HSL S 偏高，当前分区饱和度较强。",
        luminanceDark: "HSL L 偏低，当前分区整体偏暗。",
        luminanceNeutral: "HSL L 居中，当前分区亮度中性。",
        luminanceBright: "HSL L 偏高，当前分区整体偏亮。",
        hslLightnessTitle: "HSL 明度结论",
        hslHueTitle: "HSL 色相结论",
        hslSaturationTitle: "HSL 饱和度结论",
        empty: "当前分区缺少统计数据，暂无法输出倾向解释。",
      },
    },
  },
  gapCards: {
    title: "差距",
    cardTitle: "差距卡片",
    drawerOpen: "展开差距",
    drawerClose: "收起差距",
    gapScore: "差距分 {score}",
    gapConclusion: "当前{current}，与目标{target}存在明显差距。",
    actionSuggestion: "建议先执行{action}。",
    riskHint: "若处理过度，可能出现{risk}。",
    viewAll: "临时查看全部",
    viewAllDialogTitle: "Comparison 分析日志（临时）",
    viewAllTabFull: "完整日志",
    viewAllTabProcessed: "处理后日志",
    viewAllTabHistogramAi: "直方图 AI 输入",
    noLogData: "暂无 comparison 日志数据",
    noProcessedLogData: "暂无处理后日志数据",
    noHistogramAiData: "暂无直方图 AI 输入数据",
    downloadJson: "下载 JSON",
    expandEvidence: "查看详情",
    viewDetails: "查看详情",
    evidenceComingSoon: "查看详情暂未开放",
    untitledGap: "差距项 {index}",
    labels: {
      current: "现状",
      target: "目标",
      source: "Source",
      reference: "Reference",
    },
    fallback: {
      tone: {
        title: "曝光层次差距",
        currentState: "高光偏硬且暗部层次不足",
        targetState: "高光柔和，暗部保留纹理",
        actionHint: "先回收高光，再轻抬黑位建立层次",
        riskNote: "高光回收过度会让画面发灰",
      },
      color: {
        title: "综合色偏差距",
        currentState: "整体偏冷且肤色偏青",
        targetState: "中性偏暖且肤色更自然",
        actionHint: "先微调白平衡，再压低偏青倾向",
        riskNote: "暖色推进过度会导致肤色偏橙",
      },
      contrast: {
        title: "对比节奏差距",
        currentState: "中间调堆积且反差节奏偏平",
        targetState: "中间调清晰且层次过渡更有张力",
        actionHint: "先拉开中间调，再控制黑白场边界",
        riskNote: "对比拉得过猛会丢失暗部细节",
      },
    },
  },
  gapDetail: {
    previousGap: "上一个",
    nextGap: "下一个",
    gapSelectorLabel: "切换差距项",
  },
  compareStage: {
    title: "双图对照分析",
    subjectLabel: "对照目标",
    uploadViewLabel: "上传图版本",
    subjects: {
      upload: "上传图",
      reference: "参考图",
    },
    views: {
      original: "原图",
      processed: "处理图",
      cropped: "裁剪图",
    },
    metrics: {
      exposureDelta: "曝光差",
      contrastDelta: "对比差",
      temperatureDelta: "色温差",
      saturationDelta: "饱和差",
    },
    errors: {
      referenceLoadFailed: "参考图加载失败，可重试。",
      referenceMissing: "参考图缺失（上下文失效）。",
    },
    actions: {
      retry: "重试",
      downloadReference: "下载参考图",
      openEvidence: "查看证据",
      expand: "展开",
      collapse: "折叠",
    },
  },
  // 1-A：手机档（≤720）分段导航（四段：摘要 / 对照 / 缺口 / 洞察）。key 取通用含义，不绑定具体措辞。
  segments: {
    ariaLabel: "结果分区",
    summary: "摘要",
    compare: "对照",
    gaps: "缺口",
    insights: "洞察",
  },
  summaryBar: {
    targetLabel: "目标",
    gapsLabel: "关键缺口",
    gapsNone: "无",
    expand: "展开任务摘要",
    collapse: "收起任务摘要",
  },
  imageDisplay: {
    original: "原图",
    analyzed: "分析图",
    borderCropping: "边框裁剪",
    downloadOriginal: "下载原图",
    downloadProcessed: "下载处理图",
    originalImage: "原图",
    originalImageFull: "原图（完整尺寸）",
    processedImage: "处理图",
    processedImageFull: "处理图（完整尺寸）",
  },
  featureGate: {
    titles: {
      unavailable_tier: "当前套餐不支持该功能",
      insufficient_credits: "当前积分不足",
      locked: "该功能需要解锁后使用",
      default: "当前功能暂不可用",
    },
    descriptions: {
      unavailable_tier: "请升级套餐后继续使用。",
      insufficient_credits: "请前往控制台充值或升级后继续使用。",
      locked: "确认扣点后即可解锁当前图片下该功能。",
      default: "请稍后重试或前往控制台处理。",
    },
    statusLabels: {
      unavailable_tier: "套餐限制",
      insufficient_credits: "积分不足",
      locked: "待解锁",
      default: "暂不可用",
    },
    primaryActions: {
      locked: "立即解锁",
      need_confirm: "立即解锁",
      upgrade_only: "升级套餐",
      insufficient_credits: "去充值/升级",
      default: "前往控制台",
    },
    secondaryActions: {
      dismiss: "取消",
      learn_more: "了解更多",
      later: "稍后再说",
      locked: "了解更多",
      need_confirm: "了解更多",
      upgrade_only: "了解更多",
      insufficient_credits: "稍后再说",
    },
  },
  confirmDialog: {
    cancel: "取消",
    creditsRequired: "预计消耗积分",
    upgrade: {
      title: "确认升级AI分析版本",
      currentVersion: "当前版本",
      targetVersion: "目标版本",
      executing: "正在升级...",
      targetReady: "目标版本结果已就绪，升级后可立即查看",
      upgrading: "升级中",
      confirm: "确认升级",
    },
    unlock: {
      title: "确认解锁能力",
      balanceTotal: "当前可用积分",
      executing: "正在解锁...",
      unlocking: "解锁中",
      confirm: "确认解锁",
      messageZero: "该功能无需消耗积分，是否继续解锁？",
      messageSingular: "该功能需消耗 1 积分，是否继续解锁？",
      messagePlural: "该功能需消耗 {credits} 积分，是否继续解锁？",
      messageUnknown: "该功能需消耗积分，是否继续解锁？",
    },
  },
};
